<ngb-carousel
  [interval]="0"
  class="h-100"
  [showNavigationArrows]="config.indicator && getSlids().length > 1"
  [showNavigationIndicators]="config.dots && getSlids().length > 1"
>
  <ng-template ngbSlide *ngFor="let slide of getSlids(); let i = index; trackBy: trackByFn" class="h-100">
    <div (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)" class="picsum-img-wrapper d-flex h-100">
      <div
        class="grid-layout h-100 overflow-hidden w-100"
        [ngStyle]="{
          'grid-template-columns': 'repeat(' + (responsive.noOfColumn || responsive.items) + ', 1fr)',
          'grid-template-rows': responsive.noOfRows ? 'repeat(' + responsive.noOfRows + ', 1fr)' : 'auto',
        }"
      >
        <div
          class="grid-item overflow-hidden"
          *ngFor="let img of slide; let i = index"
          [ngStyle]="{
            'grid-area': responsive && responsive.area ? responsive.area[i] : '',
          }"
        >
          <img [src]="environment.imageUrl + img" class="img-fluid carasoul-image w-100 h-100" alt="" />
        </div>
      </div>
    </div>
  </ng-template>
</ngb-carousel>
